import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { X } from "lucide-react";
import { CreateOptionPickerProps } from "./types";
import { OptionCard, OptionIconWrapper } from "./style";

const CreateOptionPickerCst: React.FC<CreateOptionPickerProps> = ({
  open,
  onClose,
  title,
  options,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          backgroundColor: theme.palette.background.default,
          borderRadius: "16px",
          border: `1px solid ${theme.palette.divider}`,
        },
      }}
    >
      <DialogTitle
        sx={{
          position: "relative",
          padding: "20px 24px",
          color: theme.palette.text.primary,
        }}
      >
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: 700,
            textAlign: "center",
            px: 4,
          }}
        >
          {title}
        </Typography>
        <IconButton
          onClick={onClose}
          aria-label="close"
          sx={{
            position: "absolute",
            top: 12,
            right: 12,
            color: theme.palette.text.primary,
          }}
        >
          <X size={20} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ padding: "8px 24px 24px" }}>
        <Grid container spacing={2}>
          {options.map((option) => {
            const card = (
              <OptionCard
                disabled={option.disabled}
                onClick={() => {
                  if (option.disabled) return;
                  option.onSelect();
                }}
              >
                <OptionIconWrapper>{option.icon}</OptionIconWrapper>
                <Typography
                  sx={{
                    fontSize: "18px",
                    fontWeight: 700,
                    color: theme.palette.primary.main,
                  }}
                >
                  {option.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "13px",
                    color: theme.palette.text.primary,
                    lineHeight: 1.5,
                  }}
                >
                  {option.description}
                </Typography>
              </OptionCard>
            );

            return (
              <Grid key={option.key} item xs={12} md={4}>
                {option.disabled && option.disabledReason ? (
                  <Tooltip title={option.disabledReason} placement="top">
                    <span style={{ display: "block", height: "100%" }}>
                      {card}
                    </span>
                  </Tooltip>
                ) : (
                  card
                )}
              </Grid>
            );
          })}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default CreateOptionPickerCst;
